import { http } from '@/services/http'

export default {
  createCompetition(params) {
    return http.post('/competition', params)
  },
  getCompetitions(params) {
    return http.get('/competition', {
      params
    })
  },
  getOneCompetition({ id }) {
    return http.get(`/competition/${id}`)
  },
  updateCompetition({ id, data }) {
    return http.put(`/competition/${id}`, data)
  },
  updateCompetitionStatus({ id, status }) {
    return http.put(`/competition/status/${id}`, { status })
  },
  deleteCompetition({ id }) {
    return http.delete(`/competition/${id}`)
  },
  cloneConfiguration({ id, email }) {
    return http.post(`/competition/${id}/clone`, { approval_email: email })
  }
}



// WEBPACK FOOTER //
// ./src/services/api/competition.js